import PaginationDataResourceModel from '../../generated/types/model/resource/PaginationDataResourceModel';

export default class PaginationDataResourceViewModel extends PaginationDataResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
